export const MINUTES_OUTDATED_INFO = 1000 * 60 * 5
export const REACT_QUERY_GENERAL = {
  retry: 3,
  staleTime: MINUTES_OUTDATED_INFO,
  refetchOnWindowFocus: false
}

